import { useEffect } from 'react';

/**
 * Hook para manejar la integración con N8N Daemon en el chat.
 * Detecta y procesa hilos creados por N8N, actualizando el estado de threads y actividad global.
 *
 * @param {Object} params
 * @param {Object} params.newlyCreatedThreadData - Datos del nuevo thread creado por N8N (puede ser null)
 * @param {Function} params.setThreads - Setter para actualizar la lista de threads
 * @param {Function} params.setHasUnreadDaemonActivity - Setter para el indicador global de actividad
 * @param {Function} params.clearNewlyCreatedThreadData - Función para limpiar el dato tras procesar
 */
export function useN8NDaemonHandler({
  newlyCreatedThreadData,
  setThreads,
  setHasUnreadDaemonActivity,
  clearNewlyCreatedThreadData
}) {
  useEffect(() => {
    if (newlyCreatedThreadData) {
      const { thread: newN8NThread, initialItem } = newlyCreatedThreadData;
      console.log('[Chat] Detected new thread from N8N Daemon:', newN8NThread, initialItem);

      setThreads(prevThreads => {
        if (prevThreads.find(t => t.id === newN8NThread.id)) {
          return prevThreads; // Ya existe, no hacer nada
        }
        // Añadir propiedades para la UI y para el mensaje inicial si no se selecciona el hilo
        const threadForState = {
          ...newN8NThread,
          isUnreadByDaemon: true,
          _initialDaemonItem: initialItem
        };
        return [threadForState, ...prevThreads];
      });

      setHasUnreadDaemonActivity(true);
      clearNewlyCreatedThreadData();
    }
  }, [newlyCreatedThreadData, setThreads, setHasUnreadDaemonActivity, clearNewlyCreatedThreadData]);
} 